import { dataSourceItem } from "../../redux/models/reduxModels";
import { IDropdownOption } from "@fluentui/react";
import { DatasourceService } from "../../services/DatasourceService";

export class dataSourceDropdownBinder {
  constructor(
    private datesourceService: DatasourceService,
    private datasource: dataSourceItem,
    private displayName: string
  ) { }

  getDatasourceEntries = async () => {
    const result = await this.datesourceService.GetData({
      id: this.datasource.id,
      tenantId: this.datasource.tenantId,
      typeId: this.datasource.type.id,
      typeName: this.datasource.type.name,
      name: this.datasource.name,
      queryParams: [{ name: this.getDataSourcePropertyToBindTo(), value: "" }],
      returnOnlyQueriedProperties: true,
      allowCache: this.datasource.allowCache
    });

    return result;
  };

  getDataSourcePropertyToBindTo = () => {
    const boundedField = this.datasource && this.datasource.boundFields?.find(item => item?.name?.split(",").some(name => name?.trim().toLowerCase() === this.displayName?.trim().toLowerCase()));
    return boundedField?.datasourceField ? boundedField.datasourceField.trim() : boundedField?.name?.trim();
  };

  bindDataSourceToDropdown = (data: any[], property: string): IDropdownOption[] => {
    if (data?.length > 0) {
      const mappedPropertyKey: string = Object.keys(data[0])?.find(key => key.toLowerCase().trim() == property.toLowerCase().trim());
      if (mappedPropertyKey) {
        const arr: IDropdownOption[] = data.filter(item => item[mappedPropertyKey]?.trim().length > 0).map(item => ({ key: item[mappedPropertyKey], text: item[mappedPropertyKey] }));
        return arr
          .filter((v, i, a) => a.findIndex(t => (t.key === v.key)) === i)
          .sort((a, b) => (a.key as string).toUpperCase().trim() < (b.key as string).toUpperCase().trim() ? -1 : 1);
      }
    }
    return [];
  };
}